<app-sale-credit-note-grid
[permissionKey]="'saleCreditNotes.list'"
[filter]="['ThirdId.Id eq ' + element.Id]"
(add)="onAddButtonClicked()"
[columns]="SaleCreditNoteColumns"
></app-sale-credit-note-grid>